import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdTrash, IoMdWarning } from 'react-icons/io';
import { Modal as ModalAnt } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import { useFormikContext } from 'formik';

import { isBounceWebview, postMessageToRN } from 'legacy/common/utils/webview';
import { WEBVIEW_CLOSE } from 'legacy/common/constants/webview';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

import { useDeleteEvent, useGetEvent } from '../../../hooks';

const DangerZone = ({ eventId, navigateToSeriesSettings }) => {
  const { t } = useTranslation(['events']);
  const [isSeriesWarningModalOpen, setIsSeriesWarningModalOpen] =
    useState(false);
  const router = useRouter();
  const deleteEventCommand = useDeleteEvent();
  const { data: event } = useGetEvent(eventId);
  const { setFieldValue } = useFormikContext();

  const toggleSeriesWarningModal = () => {
    setIsSeriesWarningModalOpen((prevState) => !prevState);
  };

  const setEventToPrivate = () => {
    setFieldValue('private', true);
    toggleSeriesWarningModal();
  };

  const deleteEvent = () => {
    if (event.seriesId) {
      toggleSeriesWarningModal();
    } else {
      ModalAnt.confirm({
        title: t('events:dangerZone.deleteEvent'),
        icon: <ExclamationCircleOutlined />,
        content: t('events:dangerZone.deleteEventConfirmation'),
        centered: true,
        okText: t('events:dangerZone.yes'),
        okType: 'danger',
        cancelText: t('events:dangerZone.no'),
        onOk() {
          deleteEventCommand.mutate(eventId, {
            onSuccess: () => {
              if (isBounceWebview()) {
                postMessageToRN(WEBVIEW_CLOSE);
              } else {
                router.push('/host');
              }
            }
          });
        }
      });
    }
  };

  return (
    <>
      <div className="mt-6">
        <h3 className="font-semibold text-lg">
          {t('events:dangerZone.title')}
        </h3>
        <div className="flex items-center justify-between px-4 py-5 border-1 border-red-700 rounded-lg mt-4 bg-red-50">
          <div className="flex items-center">
            <IoMdTrash size={24} />
            <span className="ml-2 text-base">
              {t('events:dangerZone.deleteEvent')}
            </span>
          </div>
          <button
            type="button"
            className="text-base text-red-700 font-bold cursor-pointer"
            onClick={deleteEvent}
          >
            {t('events:dangerZone.deleteButton')}
          </button>
        </div>
      </div>
      <Modal
        visible={isSeriesWarningModalOpen}
        onClose={toggleSeriesWarningModal}
        type={ModalType.SMALL}
        autoHeight
        title={t('events:dangerZone.seriesModal.title')}
        icon={
          <div className="bg-red-100 flex-1 h-full flex items-center justify-center text-red-800">
            <IoMdWarning size={20} />
          </div>
        }
      >
        <div className="p-4">
          <p className="text-base font-normal text-neutral-600">
            {t('events:dangerZone.seriesModal.description')}
          </p>
          <div className="flex gap-4 pt-8 pb-4">
            <Button
              type={ButtonType.Primary}
              onClick={navigateToSeriesSettings}
              newRadius
            >
              {t('events:dangerZone.seriesModal.updateSettings')}
            </Button>
            <Button
              type={ButtonType.Primary}
              onClick={setEventToPrivate}
              newRadius
            >
              {t('events:dangerZone.seriesModal.setToPrivate')}
            </Button>
          </div>
          <Button
            type={ButtonType.Inverted}
            onClick={toggleSeriesWarningModal}
            newRadius
          >
            {t('events:dangerZone.seriesModal.cancel')}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DangerZone;
